'use client'
import { usePresenceStore } from '../../stores/presence.store'

const STATUS_COLOR = {
  online:  '#34d399',
  busy:    '#fbbf24',
  offline: '#475569',
} as const

export default function PresenceDock() {
  const { services } = usePresenceStore()

  return (
    <div style={{
      borderTop:  '1px solid rgba(255,255,255,0.06)',
      padding:    '10px 14px 12px',
      background: 'rgba(0,0,0,0.25)',
    }}>
      

      {services.map((svc) => (
        <div
          key={svc.id}
          title={svc.detail}
          style={{ display: 'flex', alignItems: 'center', gap: 9, padding: '4px 0', cursor: 'default' }}
        >
          
        </div>
      ))}

      <style>{`
        @keyframes pulse {
          0%, 100% { opacity: 1 }
          50%       { opacity: 0.4 }
        }
      `}</style>
    </div>
  )
}
